import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';

import LoadingPage from '@/pages/loading';

const AuthCallbackPage = () => {
  const { error, isAuthenticated, isLoading } = useAuth();
  const { t } = useTranslation();

  if (isLoading)
    return (
      <LoadingPage>
        <p>{t('AuthCallback.message')}</p>
      </LoadingPage>
    );

  if (error || !isAuthenticated) throw new Error(error?.message ?? 'Unable to authenticate');

  return <Navigate to="/" replace />;
};
AuthCallbackPage.displayName = 'AuthCallbackPage';

export default AuthCallbackPage;
